export const normalizeEmail = value => String(value || '').trim().toLowerCase();

const fold = value => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const validateNewPassword = (password, identity = {}) => {
    const value = String(password || '');
    const folded = fold(value);
    const bytes = typeof TextEncoder !== 'undefined'
        ? new TextEncoder().encode(value).length
        : unescape(encodeURIComponent(value)).length;
    const tokens = [fold(identity.email).split('@')[0], identity.username, identity.fullname]
        .flatMap(item => fold(item).split(/[^a-z0-9]+/))
        .filter(item => item.length >= 3);
    if (value.length < 12) return 'Usa al menos 12 caracteres.';
    if (value.length > 64) return 'Usa como máximo 64 caracteres.';
    if (bytes > 72) return 'La contraseña supera el máximo permitido en bytes.';
    if (/^(.)\1{11,}$/u.test(value) || /^(..+)\1{5,}$/u.test(value))
        return 'Evita caracteres o patrones repetidos.';
    if (tokens.some(token => folded.includes(token)))
        return 'La contraseña no debe contener tu nombre o correo.';
    return '';
};

export const isCaptchaError = body => ['captcha-required', 'captcha-invalid'].includes(body?.msg);

export const consumeCaptchaToken = (state, submittedToken, tokenField = 'token', keyField = 'key') => {
    if (!submittedToken || state[tokenField] !== submittedToken) return state;
    return {
        ...state,
        [tokenField]: '',
        [keyField]: (state[keyField] || 0) + 1
    };
};

export const requireCaptchaAfterAttempt = (state, submittedToken, {
    requiredField = 'required', tokenField = 'token', keyField = 'key', extra = {}
} = {}) => {
    const next = { ...state, ...extra, [requiredField]: true };
    if (submittedToken) {
        const actionChanged = extra.action !== undefined && extra.action !== state.action;
        return actionChanged ? { ...next, [tokenField]: '' } : next;
    }
    return {
        ...next,
        [tokenField]: '',
        [keyField]: (state[keyField] || 0) + 1
    };
};
